<template>
    <div class="v-flex mt-1 secondary lighten-4" style="height: calc(100% - 55px); margin-right: 70px; overflow: hidden">
        <div style="width: 35%">
            <p-inc-outbox-filter
                :loading = "loading"
                :steps   = "steps"
                @filter  = "onLoad"
                @step    = "onStep"
                @search  = "onSearch"
            />

            <div class="mt-2 ml-3 ">
                <virtual-scroller
                    v-if           = "entries"
                    :items         = "filteredEntries"
                    :min-item-size = "50"
                    key-field      = "id"
                    :prerender     = "1"
                    :style         = "'max-height:' + (height - 60) + 'px'"
                    class          = "dialog-border"
                    style          = "width: calc(100% + 14px)"
                    v-slot         = "{ item }"
                >
                    <div class="mr-2">
                        <div v-if="item.date" class="pt-2 pl-1 primary--text mail-header">
                            {{ item.date }}
                        </div>

                        <p-inc-outbox-entry
                            class     = "w-100"
                            :class    = "border(item) + ' ' +((selected && selected.id === item.id) ? 'background-selected' : 'white')"
                            :mail     = "item"
                            @selected = "onSelected"
                        />
                    </div>
                </virtual-scroller>
            </div>
        </div>

        <div class="dialog-border mt-3 mr-3 pl-2" style="width: 65%; margin-left: 14px; overflow: hidden"
             :style="'height: ' + (height + 156) + 'px'"
        >
            <p-inc-outbox-mail
                v-if         = "mail"
                :mail        = "mail"
                :height      = "height"
                :incident-id = "selected.incidentId"
                @close       = "onClose"
            />
        </div>
    </div>
</template>

<script>

import Core from "@/modules/core/service/Core";
import Inc from "@/modules/inc/service/Inc";
import PIncOutboxFilter from "@/modules/inc/outbox/components/private/PIncOutboxFilter.vue";
import PIncOutboxEntry from "@/modules/inc/outbox/components/private/PIncOutboxEntry.vue";
import Dms from "@/modules/dms/common/service/Dms";
import PIncOutboxMail from "@/modules/inc/outbox/components/private/PIncOutboxMail.vue";

export default {
    name: "PIncOutbox",

    components: {
        PIncOutboxMail,
        PIncOutboxEntry,
        PIncOutboxFilter,
    },

    props: {
        height: {

        },
    },

    data: () => ({
        entries: null,
        filteredEntries: null,
        step: null,
        steps: null,
        selected: null,
        mail: null,
        loading: false,
        search : null
    }),

    mounted() {
    },

    methods: {
        onHome() {
            Core.nav.home(this);
        },

        onSelected (entry) {
            this.selected = entry;
            Dms.prepare(this, this.selected.id, ((type, data) => {
                this.mail = data;
                this.mail.id = this.selected.id;
            }));
        },

        onStep (step) {
            this.step = step;
            this.onFilter();
        },

        onClose () {
            this.$emit("close");
        },

        onLoad (filter) {
            this.loading = true;

            this.selected = null;
            this.mail = null;

            const typeId = filter.type ? filter.type.id : null;
            Inc.outbox.findOutboxEntries(filter.customerIds, filter.from, filter.to, typeId, filter.mymails).then(data=> {
                this.entries = data;
                this.steps = [...new Set(this.entries.map (e => {
                    return {
                        name: e.stepName
                    }
                })) ];
                this.steps.sort((a, b) => a.name.localeCompare(b.name));
                this.steps.unshift ({
                    id  : 0,
                    name: "---"
                });

                this.onSearch();
                this.loading = false;
            });
        },

        border (entry) {
            if (entry.date && entry.end) {
                return "top-bottom-border-radius";
            }

            if (entry.date) {
                return "top-border-radius";
            }

            if (entry.end) {
                return "bottom-border-radius";
            }

            return "middle-border-radius";
        },

        onSearch (search) {
            this.search = search;
            this.onFilter();
        },

        onFilter () {
            if (!this.search) {
                this.filteredEntries = this.entries;
            } else {
                this.filteredEntries = this.entries.filter(e => {
                    if (Core.filter.includes(e.subject, this.search)) {
                        return true;
                    }

                    if (Core.filter.includes(e.to, this.search)) {
                        return true;
                    }

                    return (Core.filter.includes(e.stepName, this.search));
                });
            }

            this.filteredEntries = this.filterSteps(this.filteredEntries);

            let date = "";
            let prev = null;
            this.filteredEntries.forEach (entry => {
                const entryDate = Core.format.date.display(entry.sended);
                if (entryDate !== date) {
                    if (prev) {
                        prev.end = true;
                    }

                    date = entryDate;
                    entry.size = 127;
                    entry.date = entryDate;
                    prev = null;
                } else {
                    entry.date = null;
                    entry.size = 92;
                }

                prev = entry;
            });

        },

        filterSteps (entries) {
            if (!this.step) {
                return entries;
            }

            return entries.filter(e => e.stepName === this.step.name);
        }
    }
}
</script>

<style scoped>

.mail-header {
    height: 35px;
    font-size: 17px;
    font-weight: 600;
}

div::-webkit-scrollbar {
    width: 8px !important;
    border-radius: 4px;
}

</style>